import { render, staticRenderFns } from "./UtilityModelPatent.vue?vue&type=template&id=d584e070&scoped=true&"
import script from "./UtilityModelPatent.vue?vue&type=script&lang=js&"
export * from "./UtilityModelPatent.vue?vue&type=script&lang=js&"
import style0 from "./UtilityModelPatent.vue?vue&type=style&index=0&id=d584e070&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d584e070",
  null
  
)

export default component.exports